import type { FunctionComponent } from 'react';

function getDisplayName<P>(WrappedComponent: FunctionComponent<P>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function HOCWithDisplayName(hocName: string) {
  return function addDisplayName<P>(WrappedComponent: FunctionComponent<P>) {
    // eslint-disable-next-line no-param-reassign
    WrappedComponent.displayName = `${hocName}(${getDisplayName(
      WrappedComponent,
    )})`;

    return WrappedComponent;
  };
}
